import defaultState from "./state";
const initialState = { ...defaultState };

const DenunciasReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "LOADING_DENUNCIAS_EMPRESA": {
      return Object.assign({}, state, {
        isLoading: action.isLoading,
      });
    }
    case "LOADING_DENUNCIAS_DOWNLOAD_EXCEL": {
      return Object.assign({}, state, {
        isDownloadLoading: action.isDownloadLoading,
      });
    }
    case "SET_DENUNCIAS_EMPRESA": {
      return Object.assign({}, state, {
        listaDenuncias: action.listaDenuncias,
        totalDenuncias: action.total,
      });
    }
    case "SET_STATE_AFTER_DELETE_DRAFT": {
      return Object.assign({}, state, {
        listaDenuncias: action.listaDenuncias,
        listaDenunciasFiltrada: action.listaDenunciasFiltrada,
        showHideForm: action.showHideForm,
        shouldUpdateDataGrid: true,
        isModified: false,
        isOpenModalBorrador: false,
        lastCompletedStep: 1,
        activeStep: 0,
        editingDraft: false,
        dataTrabajador: {},
        pendingComplaints: [],
        jsonData: {
          Id: null,
          formInfoDenuncia: {},
          formInfoTrabajador: {
            TipoDireccion: "Ingresar la dirección",
          },
          formDatoSiniestro: {},
          formDatosEmpresa: {},
          formDenunciante: {},
          formDatosEnfermedad: {},
          currentStep: 1,
          horaPresentacion: null,
        },
      });
    }
    case "SET_DENUNCIAS_EMPRESA_FILTRADA": {
      return Object.assign({}, state, {
        listaDenunciasFiltrada: action.listaDenunciasFiltrada,
      });
    }
    case "SET_DENUNCIAS_FILTER": {
      return Object.assign({}, state, {
        filtrosDenuncias: action.filtros,
      });
    }
    case "OPEN_CLOSE_MODAL_BORRADOR_DENUNCIA": {
      return Object.assign({}, state, {
        isOpenModalBorrador: action.isOpen,
      });
    }
    case "OPEN_CLOSE_MODAL_CONTINUE": {
      return Object.assign({}, state, {
        isOpenModalContinue: action.isOpen,
      });
    }
    case "OPEN_CLOSE_MODAL_DELETE": {
      return Object.assign({}, state, {
        isOpenModalDelete: action.isOpen,
      });
    }
    case "SET_SHOWHIDE_FORM_DENUNCIA": {
      const actualState = { ...state };
      if (!action.showHideForm) actualState.activeStep = 1;
      return Object.assign({}, state, {
        showHideForm: action.showHideForm,
        activeStep: actualState.activeStep,
      });
    }
    case "SET_STEP_DENUNCIA": {
      let maxStep = state.lastCompletedStep;
      if (action.step > state.lastCompletedStep) maxStep = action.step;
      return Object.assign({}, state, {
        activeStep: action.step,
        lastCompletedStep: maxStep,
      });
    }
    case "NEXT_STEP_DENUNCIA": {
      const nextStep = state.activeStep + 1;
      return Object.assign({}, state, {
        activeStep: nextStep,
        lastCompletedStep: nextStep > state.lastCompletedStep ? nextStep : state.lastCompletedStep,
      });
    }
    case "LAST_STEP_DENUNCIA": {
      return Object.assign({}, state, {
        activeStep: state.activeStep - 1,
      });
    }
    case "SET_DATA_NEW_COMPLAIN": {
      return Object.assign({}, state, {
        jsonData: action.jsonData,
        isModified: true,
      });
    }
    case "SET_DRAFT_DENUNCIA": {
      const data = {
        Rut: action.jsonData.formInfoTrabajador.Rut,
        FirstName: action.jsonData.formInfoTrabajador.FirstName,
        LastName: action.jsonData.formInfoTrabajador.LastName,
        MothersName: action.jsonData.formInfoTrabajador.MothersName,
        Birthdate: action.jsonData.formInfoTrabajador.Birthdate,
      };
      return Object.assign({}, state, {
        jsonData: action.jsonData,
        dataTrabajador: data,
        lastCompletedStep: action.jsonData.lastCompletedStep,
      });
    }
    case "EDITING_DRAFT_DENUNCIA": {
      return Object.assign({}, state, {
        editingDraft: action.editing,
      });
    }
    case "SET_DATA_COMPANY_SELECTED": {
      return Object.assign({}, state, {
        dataCompany: action.company,
      });
    }
    case "SET_TIPO_DENUNCIA": {
      return Object.assign({}, state, {
        selectedTipoDenuncia: action.tipo,
      });
    }
    case "SET_CIUDADES_COMUNAS": {
      return Object.assign({}, state, {
        listaComunas: action.comunas,
        listaCiudades: action.ciudades,
      });
    }
    case "SET_CIUDADES_COMUNAS_SINIESTRO": {
      return Object.assign({}, state, {
        listaComunasSiniestro: action.comunas,
        listaCiudadesSiniestro: action.ciudades,
      });
    }
    case "SET_CODIGO_AREA": {
      return Object.assign({}, state, {
        listaCodigoArea: action.codigo,
      });
    }
    case "SET_CODIGO_AREA_ALL": {
      return Object.assign({}, state, {
        listaCodigoAreaAll: action.codigo,
      });
    }
    case "SET_DATA_TRABAJADOR_DENUNCIA": {
      return Object.assign({}, state, {
        dataTrabajador: action.data,
      });
    }
    case "UPDATE_DATA_GRID_DENUNCIAS": {
      return Object.assign({}, state, {
        shouldUpdateDataGrid: action.update,
      });
    }
    case "SET_PENDING_COMPLAINTS": {
      return Object.assign({}, state, {
        pendingComplaints: action.complaints,
      });
    }
    case "SET_ID_COMPLAINT": {
      return Object.assign({}, state, {
        IdComplaint: action.idComplaint,
      });
    }
    case "DISABLE_NEW_COMPLAINT_BUTTON": {
      return Object.assign({}, state, {
        disableContinueNewComplaint: action.disable,
      });
    }
    case "SET_MAIN_FILTERS_DENUNCIAS": {
      return Object.assign({}, state, {
        mainFilters: action.mainFilters,
      });
    }
    case "SET_FILTER_TIPO_SINIESTROS": {
      return Object.assign({}, state, {
        filtroTipoSiniestro: action.filtroTipoSiniestro,
      });
    }
    case "SET_VALID_SUCURSALES_DENUNCIA": {
      return Object.assign({}, state, {
        validSucursales: action.sucursales,
      });
    }
    case "SET_CLEAN_DATA_COMPLAIN": {
      return Object.assign({}, state, {
        isModified: false,
        isOpenModalBorrador: false,
        lastCompletedStep: 1,
        activeStep: 0,
        editingDraft: false,
        dataTrabajador: {},
        pendingComplaints: [],
        IdComplaint: null,
        jsonData: {
          Id: null,
          formInfoDenuncia: {},
          formInfoTrabajador: {
            TipoDireccion: "Ingresar la dirección",
          },
          formDatoSiniestro: {},
          formDatosEmpresa: {},
          formDenunciante: {},
          formDatosEnfermedad: {},
          currentStep: 1,
          horaPresentacion: null,
        },
      });
    }
    case "RESET_DENUNCIAS_EMPRESA": {
      return Object.assign({}, state, initialState);
    }
    case "SET_SORT_DENUNCIAS_BY_FECHA_DENUNCIA": {
      return Object.assign({}, state, {
        sortDenunciasByFechaDenuncia: action.sort,
      })
    }
    default:
      return state;
  }
};

export default DenunciasReducer;
